export const TRANSPORTE = [
  'camion',
  'acoplado'
]
